import type { ChatError, ChatMessage } from '../types';
import type { ChatRuntimeSnapshot } from './types';

/**
 * Pure projection of runtime inputs into a `ChatRuntimeSnapshot`. Phase 1 takes
 * Vantage `ChatMessage[]` directly; Phase 2 will extend the function to project
 * AG-UI native message arrays into this same shape.
 * @param messages - the messages to surface to the UI
 * @param phase - run phase: 'idle' when inactive, 'thinking' before first token, 'streaming' once text begins
 * @param runId - the active run id, or null when no run is in flight
 * @param lastError - the most recent terminal error, or null
 * @returns a frozen `ChatRuntimeSnapshot` suitable for context/UI consumption.
 */
export const toSnapshot = (
  messages: ChatMessage[],
  phase: 'idle' | 'thinking' | 'streaming',
  runId: string | null,
  lastError: ChatError | null
): ChatRuntimeSnapshot => ({
  messages,
  isStreaming: phase !== 'idle',
  phase,
  runId,
  lastError
});
